import React from "react";
import { useParams, Navigate } from "react-router-dom";
import InnerPageLayout from "../components/Layout/InnerPageLayout";
import BreadCrumb from "../components/Breadcrumb/BreadCrumb";
import ProjectRequirement from "../components/Projects/ProjectRequirement.js"
import CardFeaturesTwo from "../components/Features/CardFeaturesTwo.js"
import servicesData from "../data/servicesData";



  
export function AboutService({ service }) {
  if (!service) return null;
  
  return (
    <section className="w-full pt-16 md:pt-[94px] pb-16 md:pb-[130px]">
      <div className="w-full mx-auto theme-container px-4">
        <div className="box-border grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 lg:gap-12 items-center">
          {/* Content Section */}
          <div className={`flex flex-col justify-center lg:col-span-5 ${service.imagePosition === 'left' ? 'lg:order-2' : 'lg:order-1'}`}>
            <h2 className="text-34 sm:text-34 md:text-48 font-semibold text-white mb-8 sm:mb-[50px]  w-full xl:w-full">
              {service.title}
            </h2>
            <p className="mb-6 sm:mb-8 md:mb-10 text-paragraph text-sm sm:text-base">
              {service.description}
            </p>
          </div>
          
          {/* Image Section */}
          <div className={`relative flex flex-col justify-center w-full lg:col-span-7 ${service.imagePosition === 'left' ? 'lg:order-1' : 'lg:order-2'}`}>
            <img
              src={service.image}
              alt={service.title}
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}


export default function ServiceDetails() {
  const { slug } = useParams();
  
  // Find service by slug
  const service = servicesData.find(s => s.slug === slug);
  
  // If service not found, redirect to services page
  if (!service) {
    return <Navigate to="/services" replace />;
  }
  
  return (
    <InnerPageLayout>
      <BreadCrumb 
        pageTitle={service.title}
        items={[
          { label: "Services", path: "/services" },
          { label: service.title, path: `/service/${slug}` }
        ]}
      />
      <AboutService service={service} />
      <ProjectRequirement 
        title={service?.projectRequirement?.title}
        challenge={service?.projectRequirement?.challenge}
        solution={service?.projectRequirement?.solution}
        impact={service?.projectRequirement?.impact}
      />
      <CardFeaturesTwo
        content={service?.features?.content}
        features={service?.features?.features}
        images={service?.features?.images}
      />
    </InnerPageLayout>
  );
}
